export const PILOT_USER = {
    first_name: 'Bob',
    last_name: 'Stone'
}